__turbopack_context__.v({
  "categoryFont": "nz_eNa_categoryFont",
  "mb1": "nz_eNa_mb1",
  "mb4": "nz_eNa_mb4",
  "wFullPlus16": "nz_eNa_wFullPlus16",
  "wFullSm": "nz_eNa_wFullSm",
});
